"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
  ARROW_KEYS: () => ARROW_KEYS,
  BACK_KEYS: () => BACK_KEYS,
  PAGE_KEYS: () => PAGE_KEYS,
  SLIDER_NAME: () => SLIDER_NAME,
  SliderOrientationProvider: () => SliderOrientationProvider,
  SliderProvider: () => SliderProvider,
  createSliderContext: () => createSliderContext,
  createSliderScope: () => createSliderScope,
  useSliderContext: () => useSliderContext,
  useSliderOrientationContext: () => useSliderOrientationContext
});
module.exports = __toCommonJS(constants_exports);
var import_create_context = require("@tamagui/create-context");
const SLIDER_NAME = "Slider";
const [createSliderContext, createSliderScope] = (0, import_create_context.createContextScope)(SLIDER_NAME);
const [SliderProvider, useSliderContext] = createSliderContext(SLIDER_NAME);
const [SliderOrientationProvider, useSliderOrientationContext] = createSliderContext(SLIDER_NAME, {
  startEdge: "left",
  endEdge: "right",
  sizeProp: "width",
  size: 0,
  direction: 1
});
const PAGE_KEYS = ["PageUp", "PageDown"];
const ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
const BACK_KEYS = {
  ltr: ["ArrowDown", "Home", "ArrowLeft", "PageDown"],
  rtl: ["ArrowDown", "Home", "ArrowRight", "PageDown"]
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ARROW_KEYS,
  BACK_KEYS,
  PAGE_KEYS,
  SLIDER_NAME,
  SliderOrientationProvider,
  SliderProvider,
  createSliderContext,
  createSliderScope,
  useSliderContext,
  useSliderOrientationContext
});
//# sourceMappingURL=constants.js.map
